import { render, staticRenderFns } from "./slider.component.vue?vue&type=template&id=f46cb97a&"
import script from "./slider.component.vue?vue&type=script&lang=ts&"
export * from "./slider.component.vue?vue&type=script&lang=ts&"
import style0 from "./slider.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "slider.component.vue"
export default component.exports